namespace RioERP.Invoices {
    export interface OrderSourcesRow {
        Id?: number;
        SourceType?: string;
    }

    export namespace OrderSourcesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SourceType';
        export const localTextPrefix = 'Invoices.OrderSources';
        export const lookupKey = 'Invoices.OrderSources';

        export function getLookup(): Q.Lookup<OrderSourcesRow> {
            return Q.getLookup<OrderSourcesRow>('Invoices.OrderSources');
        }
        export const deletePermission = 'Invoices:InvoicesManagement:Modify';
        export const insertPermission = 'Invoices:InvoicesManagement:Modify';
        export const readPermission = 'Invoices:InvoicesManagement:View';
        export const updatePermission = 'Invoices:InvoicesManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            SourceType = "SourceType"
        }
    }
}
